import React, { PropsWithChildren } from "react";
import { canManageAdministrators } from "../common/helpers/municipalityRoles";
import MunicipalityRoleAuthorized from "./MunicipalityRoleAuthorized";

const AdministratorAuthorized = (props: PropsWithChildren<{}>) => (
    <MunicipalityRoleAuthorized
        canAccess={(user) => canManageAdministrators(user.municipalityRole)}
    >
        {props.children}
    </MunicipalityRoleAuthorized>
);

export default AdministratorAuthorized;
